<template>
  <div v-loading="loading" class="app-container">
    <router-view/>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import {useRouter} from 'vue-router'

const router = useRouter()
const loading = ref(false)

</script>

<style scoped lang="scss">
.app-container {
  height: calc(100vh - 48px);
  overflow: hidden;
  background: #F5F5F5 !important;
}
</style>